import { BasePlugin } from 'handsontable/plugins';
import { MilanoteHotEvents, MNHotInstance, MilanoteHotEvent } from '../../bridge/tableHotInstanceTypes';

// Some plugins take a settings object, while others take a boolean (indicating simply plugin enabled vs disabled)
export class MilanoteHotPlugin<SettingsType = boolean> extends BasePlugin {
    constructor(hotInstance: MNHotInstance) {
        super(hotInstance);
    }

    get milanoteHot(): MNHotInstance {
        return this.hot as MNHotInstance;
    }

    /**
     * This key will be used as a prop key when enabling this plugin in the HotTable component
     */
    static get PLUGIN_KEY(): string {
        throw new Error('PLUGIN_KEY must be implemented by subclass');
    }

    getPluginSettings(): SettingsType | undefined {
        // `this.hot` can be undefined, even though it's typed as non-optional readonly, as this
        // method can be called during component teardown after the instance has been destroyed.
        const settings = this.hot?.getSettings() as any;
        return settings?.[(this.constructor as typeof MilanoteHotPlugin).PLUGIN_KEY];
    }

    getConfig(): SettingsType {
        // Defaulting to {} covers the boolean case too, even though it's not quite type-correct
        return this.getPluginSettings() ?? ({} as SettingsType);
    }

    isEnabled(): boolean {
        return !!this.getPluginSettings();
    }

    addMilanoteHook<K extends keyof MilanoteHotEvents>(hookName: K, callback: MilanoteHotEvent<K>): void {
        this.milanoteHot.addHook(hookName, callback);
    }
}
